import { render, staticRenderFns } from "./weldCloud.vue?vue&type=template&id=64c9cd98&scoped=true"
import script from "./weldCloud.vue?vue&type=script&lang=js"
export * from "./weldCloud.vue?vue&type=script&lang=js"
import style0 from "./weldCloud.vue?vue&type=style&index=0&id=64c9cd98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9cd98",
  null
  
)

export default component.exports